import { Component, ViewChild } from '@angular/core';
import { MenuHeaderComponent } from '../menu-header/menu-header.component';
import { ApisService } from '../../../services/apis.service';
import { AppConstants } from '../../../app-constants';
import moment from 'moment';
import { Logout } from '../../../models/api-models';
import { SharedService } from '../../../services/shared.service';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FromFieldType } from '../../../models/form-field.model';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicFormBuilderComponent } from '../../../shared/dynamic-form-builder/dynamic-form-builder.component';
import { MustMatch } from '../../../infrastructure/helpers/must-match.validator';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-header',
    imports: [FormsModule, ReactiveFormsModule, MenuHeaderComponent, NgbDropdownModule, DynamicFormBuilderComponent],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @ViewChild('changePassword', { static: true }) changePassword: any;
  email='model6.support@bay6.ai'
  userName: any;
  account__Name: any;
  closeResult!: string;
   changePasswordForm!: FormGroup
chnages_password_fields:FromFieldType[]=AppConstants.field_names.changes_password

  constructor(private apis:ApisService,private sharedService:SharedService,private toasterService: ToastrService, private modalService: NgbModal){

  }
   ngOnInit(): void {
  console.log(this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).is_first_time_password_updated)
  if(this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).is_first_time_password_updated ==0){
     
        this.modalService.open(this.changePassword, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      windowClass: 'change-password'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    });
        }
  this.userName = this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).first_name + ' ' + this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).last_name
    this.account__Name = this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).Account_name
   this.getChangesPassworsdForm()
  }
   getChangesPassworsdForm() {
      let fieldsCtrls = {} as any;
      for (let f of this.chnages_password_fields) {
       
        fieldsCtrls[f.name] = new FormControl(f.value || '', f.required == true ? Validators.required : [])
      }
 this.changePasswordForm = new FormGroup(fieldsCtrls, {
    validators: MustMatch('password', 'confirmPassword')
  } as any);
    }
  logout(){
     var body: Logout = {
      activitytimeStamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      userId: this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).id
    };
    console.log(body)
    this.apis.postApi(AppConstants.apis_end_points.logout,this.sharedService.apis_encrypt(body),{}).subscribe({
       next: (data:any) => {
        console.log(data)
        data=this.sharedService.apis_decrypt(data)
if(data.success ==1){
 console.log(data)
 this.apis.cleanupOnLogout()
          // this.router.navigate([AppConstants.RoutingPaths.dashboard]);
}
  },
  error: (err:any) => {

  }
    })
  }
   open(content:any) {
    this.changePasswordForm.reset()
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      windowClass: 'change-password'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }
  closeModal() {
   if(this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).is_first_time_password_updated ==0){
this.logout()
this.modalService.dismissAll('changePassword');
   }else{
    this.modalService.dismissAll('changePassword');
   }
  }
  
submitPassword(){
    if (this.changePasswordForm.value.oldPassword == this.changePasswordForm.value.newPassword) {
      this.changePasswordForm.invalid;
    }
    if (this.changePasswordForm.valid) {
      var body = {
        password: this.changePasswordForm.value.currentPassword,
        newpassword: this.changePasswordForm.value.password,
        userid: this.sharedService.getSession(AppConstants.LocalStorage.LoggedUserDetails).id.toString(),
      };
      this.apis.postApi(AppConstants.apis_end_points.login_change_password,this.sharedService.apis_encrypt(body),{}).subscribe((data)=>{
data=this.sharedService.apis_decrypt(data)
console.log(data)
        if(data.success ==1){
          console.log(data)
        this.toasterService.success('', data.message);
          this.modalService.dismissAll('changePassword');
          this.logout()
}else{
          this.toasterService.error('', data.message);
}
      })
    }
}
handleEmailClick() {
  window.open(`mailto:${this.email}`, '_blank');

}
}
